var App = App || {};

App.CmpMediaGallery = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".cmp--mediaGallery__carousel .splide");
        const arrows = widget.find(".cmp--mediaGallery__arrows");
        const status = widget.find(".cmp--mediaGallery__status");
        let buttons = carousel.find(".splide__slide button");
        const media = widget.find(".cmp--mediaGallery__media");

        var splide = new Splide(carousel[0], {
            type: "loop",
            focus: "center",
            pagination: false,
            arrows: false,
            autoWidth: true
        });

        // Use delivered image dimensions (naturalWidth/naturalHeight), not CSS sizing,
        // to determine orientation for multi-media content.
        ApplyOrientationFromRenderedMedia(media);

        splide.on("mounted", function () {
            ApplyOrientationFromRenderedMedia(media, splide);

            const buttonActive = $(splide.Components.Slides.getAt(0).slide).find("button");
            buttonActive.attr("aria-selected", true);

            arrows.find(".splide__arrow--next").on("click", function () {
                splide.go('>');
            });

            arrows.find(".splide__arrow--prev").on("click", function () {
                splide.go('<');
            });

            buttons = carousel.find(".splide__slide button");
            buttons.on("click", function () {
                const index = $(this).data("index");
                splide.go(index);
            });

            status.children(".current").text("1");
            status.children(".divider").text("/");
            status.children(".total").text(splide.length);
        });

        splide.on("move", function (nextSlide, prevSlide) {

            // toggle aria-selected attribute for clicked button and "sibling" buttons
            const buttonActive = $(splide.Components.Slides.getAt(nextSlide).slide).find("button");
            buttons.toArray().forEach(btn => {
                btn.setAttribute("aria-selected", btn === buttonActive[0]);
            });

            // update status
            status.children(".current").text(nextSlide + 1);

            // stop all video
            const multiMedia = media.find(".cmp--multiMedia__video iframe").parents(".cmp--multiMedia__video");
            multiMedia.each(function () {
                App.CmpMultiMedia.Stop($(this));
            });

            // show/hide content for selected item
            const targetId = buttonActive.attr("aria-controls");
            const target = media.find(`.cmp--mediaGallery__media__item#${targetId}`);
            target.addClass("active").siblings(".active").removeClass("active");
        });

        splide.mount({});
    }

    function ApplyOrientationFromRenderedMedia(media, splide) {
        media.find(".cmp--multiMedia").each(function () {
            const multiMedia = $(this);

            if (multiMedia.find(".cmp--multiMedia__video").length) {
                SetOrientation(multiMedia, "landscape", splide);
                return;
            }

            const image = multiMedia.find(".cmp--multiMedia__image img").first();
            if (!image.length)
                return;

            const apply = function () {
                const node = image[0];
                const width = node.naturalWidth || node.width;
                const height = node.naturalHeight || node.height;

                if (!width || !height)
                    return;

                const orientation = width > height ? "landscape" : "portrait";
                SetOrientation(multiMedia, orientation, splide);
            };

            if (image[0].complete) {
                apply();
            }
            else {
                image.one("load.cmpMediaGalleryOrientation", apply);
            }
        });
    }

    function SetOrientation(multiMedia, orientation, splide) {
        if (multiMedia.attr("data-orientation") === orientation)
            return;

        multiMedia.attr("data-orientation", orientation);

        if (splide) {
            splide.refresh();
        }
    }

    return {
        Init: Init
    };

})(jQuery);